import { z } from "zod/v3";

export const AgentAutonomyLevelSchema = z.enum([
  "LEVEL_1",
  "LEVEL_2",
  "LEVEL_3",
]);

export type AgentAutonomyLevelDTO = z.infer<typeof AgentAutonomyLevelSchema>;

export const ProgramAutonomyOverridesDTOSchema = z
  .object({
    policyReviewCreateTasks: z.boolean(),
    policyReviewCreateExternalTickets: z.boolean(),
    proactiveEvidenceCollection: z.boolean(),
  })
  .strict();

export type ProgramAutonomyOverridesDTO = z.infer<
  typeof ProgramAutonomyOverridesDTOSchema
>;

export const ProgramAutomationSettingsDTOSchema = z
  .object({
    programId: z.string(),
    autonomyLevel: AgentAutonomyLevelSchema,
    autonomyOverrides: ProgramAutonomyOverridesDTOSchema,
  })
  .strict();

export type ProgramAutomationSettingsDTO = z.infer<
  typeof ProgramAutomationSettingsDTOSchema
>;

export const ControlGoalValueDTOSchema = z
  .object({
    evidenceRequired: z.boolean(),
    freshnessMaxHours: z.number().int().positive(),
    scanProviders: z.array(z.string()),
    requiredClaimTypes: z.array(z.string()),
    minConfidence: z.enum(["low", "medium", "high"]),
    driftAlertEnabled: z.boolean(),
  })
  .strict();

export type ControlGoalValueDTO = z.infer<typeof ControlGoalValueDTOSchema>;

export const ControlGoalOverrideItemDTOSchema = z
  .object({
    controlRef: z.string(),
    controlDefId: z.string(),
    controlTitle: z.string(),
    defaults: ControlGoalValueDTOSchema,
    resolved: ControlGoalValueDTOSchema,
    hasOverride: z.boolean(),
  })
  .strict();

export type ControlGoalOverrideItemDTO = z.infer<
  typeof ControlGoalOverrideItemDTOSchema
>;
